import { DataBean } from "../DataBean";

export class QualityTraining extends DataBean {

  public async getQualityTrainingCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityTrainingCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityTrainingRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityTrainingRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityTraining(idqualitytraining: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityTraining_Number", [idqualitytraining]);
  }

  public async updateQualityTraining(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityTraining_updateQualityTraining_com.orange.finance.processcontract.bean.QualityTraining",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityTraining",
        },
      ]
    );
  }
}
